// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"8af8c02f","821":"f6d8d003"}[chunkId] + ".chunk.js";
};